import { render, staticRenderFns } from "./FormSubStream.vue?vue&type=template&id=a45ab890&scoped=true&"
import script from "./FormSubStream.vue?vue&type=script&lang=ts&"
export * from "./FormSubStream.vue?vue&type=script&lang=ts&"
import style0 from "./FormSubStream.vue?vue&type=style&index=0&id=a45ab890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ab890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a45ab890', component.options)
    } else {
      api.reload('a45ab890', component.options)
    }
    module.hot.accept("./FormSubStream.vue?vue&type=template&id=a45ab890&scoped=true&", function () {
      api.rerender('a45ab890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Howen/RecSetup/FormSubStream.vue"
export default component.exports